
var Shopify = Shopify || {};
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);
  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) { return 0; }
    number = (number/100.0).toFixed(precision);
    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }
  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

var productDataElement = document.getElementById('product-data');
var shopPriceFormat = productDataElement.getAttribute("shop-price-format");
var shopPriceFormatWithCurrency = productDataElement.getAttribute("shop-price-format-with-currency");
var withCurrency = document.getElementById('product-price-section-2');
var withCurrency2 = document.getElementById('product-price-section-1');

  if(withCurrency){
    withCurrency = withCurrency.getAttribute("addcurrency");
  }
  else{
    withCurrency2 = withCurrency2.getAttribute("addcurrency");
  }
  
var curFormat = withCurrency != null ? withCurrency : withCurrency2;  

var productVariantsList = JSON.parse(productDataElement.dataset.product).variants;

var variantInput = document.getElementById('ultimate-selected-variant');
var variantObserver = new MutationObserver(function(mutationsList) {
  for (var mutation of mutationsList) {
    if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
      var variantValue = variantInput.value

      productVariantsList.forEach(variant => {
        if(variant.id == variantValue){
          var productPrice = document.getElementById('product-price-section-2')
          if(productPrice == null){
            productPrice = document.getElementById('product-price-section-1')
          }
          productPrice.textContent = Shopify.formatMoney(variant.price, curFormat != null ? shopPriceFormatWithCurrency : shopPriceFormat)                  
          if(variant.compare_at_price > 0){
          var productComparePrice = document.querySelector('.sale')
          productComparePrice.textContent = Shopify.formatMoney(variant.compare_at_price, curFormat != null ? shopPriceFormatWithCurrency : shopPriceFormat);
          }
          }
      })  
    }
  }
});

variantObserver.observe(variantInput, { attributes: true });



// Color dropdown <-> product image sync
(function () {
  function normalize(str) {
    return (str || "").toLowerCase().replace(/[^a-z0-9]/g, "");
  }

  function colorsMatch(a, b) {
    var na = normalize(a);
    var nb = normalize(b);
    if (!na || !nb) return false;
    return na.indexOf(nb) !== -1 || nb.indexOf(na) !== -1;
  }

  function getMainImageColor() {
    var mainImg = document.querySelector(".featured-product-image img");
    return mainImg ? mainImg.alt : "";
  }

  function findThumbForColor(color) {
    var thumbs = document.querySelectorAll(".product-img-grid-item img");
    for (var i = 0; i < thumbs.length; i++) {
      if (colorsMatch(thumbs[i].alt, color)) return thumbs[i];
    }
    for (var j = 0; j < thumbs.length; j++) {
      if (colorsMatch(thumbs[j].src, color)) return thumbs[j];
    }
    return null;
  }

  function findOptionIndexForColor(select, color) {
    var options = select.options;
    for (var i = 0; i < options.length; i++) {
      if (colorsMatch(options[i].text, color)) return i;
    }
    return -1;
  }

  document.addEventListener("change", function (e) {
    var select = e.target;
    if (!select.matches || !select.matches('select[name="option1"]')) return;
    var selectedText = select.options[select.selectedIndex].text;
    if (colorsMatch(getMainImageColor(), selectedText)) return;
    var thumb = findThumbForColor(selectedText);
    if (thumb) thumb.click();
  });

  document.addEventListener("click", function (e) {
    var img = e.target;
    if (!img.matches || !img.matches(".product-img-grid-item img")) return;
    var select = document.querySelector('select[name="option1"]');
    if (!select) return;
    var idx = findOptionIndexForColor(select, img.alt);
    if (idx === -1) idx = findOptionIndexForColor(select, img.src);
    if (idx === -1) return;
    var currentText = select.options[select.selectedIndex].text;
    if (colorsMatch(currentText, select.options[idx].text)) return;
    if (idx !== select.selectedIndex) {
      select.selectedIndex = idx;
      select.dispatchEvent(new Event("change", { bubbles: true }));
    }
  });
})();
